import { Link, useLocation } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";

/**
 * Slim, fixed bottom "Check a name" bar shown only on mobile (< md). Keeps the
 * primary conversion action one tap away while scrolling. Hidden on the pages
 * where it would be redundant (the checker itself and the checkout flow).
 */
export default function MobileCheckBar() {
  const { pathname } = useLocation();
  const hide = pathname === "/check" || pathname.startsWith("/checkout");
  if (hide) return null;

  return (
    <>
      {/* In-flow spacer so the fixed bar never sits over footer content on mobile */}
      <div className="md:hidden h-[68px]" aria-hidden="true" />
      <div
        className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white/95 backdrop-blur-md border-t border-[#9ac7f7]/45 px-4 pt-2.5 pb-[calc(0.625rem_+_env(safe-area-inset-bottom))] shadow-[0_-6px_20px_rgba(4,39,61,0.08)]"
        data-testid="mobile-check-bar"
      >
        <Link to="/check" className="btn-primary w-full justify-center text-sm py-3" data-testid="mobile-check-bar-button">
          <ShieldCheck size={16} /> Check a name <ArrowRight size={16} />
        </Link>
      </div>
    </>
  );
}
